import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import autoBind from "react-autobind";
import brasaoActions from "@common/store/brasao/brasao.actions";
import brasaoSelector from "@common/store/brasao/brasao.selectors";

class Brasao extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const { brasao } = this.props.brasaoSelector;

    if (!brasao.UrlBrasao) this.props.brasaoActions.getBrasao();
  }

  goToMainPage() {
    const { routerManager } = this.props;
    routerManager.redirect({ url: window.location.pathname });
  }

  render() {
    const { brasao } = this.props.brasaoSelector;

    return (
      <div className="header-logo">
        <a onClick={this.goToMainPage}>
          <img alt="Smarapd" src={brasao.UrlBrasao} />
        </a>
      </div>
    );
  }
}

export default connect({
  selectors: {
    brasaoSelector
  },
  actions: {
    brasaoActions
  }
})(Brasao);
